import React, {Suspense, useEffect} from "react";
import {Navigate, Route, Routes} from "react-router-dom"
import IntroPage from "../components/intro/IntroPage";
import PrivateRoute from "./route/PrivateRoute";
import MediaWall from "../pages/MediaWall";
import Web from "../pages/Web";
import PreSelection from "../components/preselection/template/PreSelection";
import Controllers from "../components/controller/Controllers";
import Remote from "../pages/Remote";
import NewModelSelect from "../components/intro/newModelSelect/NewModelSelect";
import {getDeviceType} from "../../core/utils/getDeviceType";


const MediaWallStyleRoute = React.lazy(() => import("./route/MediaWallStyleRoute"));
const RemoteStyleRoute = React.lazy(() => import("./route/RemoteStyleRoute"));
let DeviceStyleRoute;



const Router = () => {
  const deviceType = getDeviceType();

  sessionStorage.setItem("deviceType", deviceType);


  if (deviceType === "desktop") {
    DeviceStyleRoute = React.lazy(() => import("./route/DesktopStyleRoute"));
  } else if (deviceType === "tablet") {
    DeviceStyleRoute = React.lazy(() => import("./route/TabletStyleRoute"));
  } else if (deviceType === "mobile") {
    DeviceStyleRoute = React.lazy(() => import("./route/MobileStyleRoute"));
  }



  return (
    <Suspense fallback={<div></div>}>
      <Routes>
        <Route path={"/"} element={<Navigate to={"/en/intro"}/>}/>
        <Route path={"/tablet"} element={<Navigate to={"/en/tablet"}/>}/>
        <Route path={"/mediawall"} element={<Navigate to={"/en/mediawall"}/>}/>


        <Route element={<RemoteStyleRoute/>}>
          <Route path={"/:lang/tablet"} element={<Remote/>}/>
        </Route>

        <Route element={<MediaWallStyleRoute/>}>
          <Route path={"/:lang/mediawall"} element={<MediaWall/>}/>
        </Route>


        <Route element={<DeviceStyleRoute/>}>

          <Route path={"/:lang/intro"} element={<IntroPage/>}/>
          <Route path={"/code/:bespokeCode"} element={<IntroPage/>}/>

          <Route element={<PrivateRoute/>}>
            <Route path={":lang/model-select"} element={<NewModelSelect/>}/>
            <Route path={"/:lang/:id/*"} element={<Web/>}>
              <Route path={"collection"} element={<PreSelection/>}/>
              <Route path={"configurator/:conf"} element={<Controllers/>}/>
              {/*<Route path={"summary"} element={<Summary/>}/>*/}
            </Route>
          </Route>

        </Route>

        <Route path="*" element={<Navigate to={"/en/intro"}/>}/>
      </Routes>
    </Suspense>
  )
}
export default Router;
